module.exports = __webpack_public_path__ + "img/Presentation41.1c654411.png";